import { useState, useEffect, useRef } from "react";

const useRefresher = (query) => {
  const [refreshCounter, setRefreshCounter] = useState(3);
  const [userActive, setUserActive] = useState(true);
  const refreshTimerRef = useRef();

  const invalidateData = () => {
    if (query?.status === "fulfilled" && typeof query?.refetch === "function") {
      query?.refetch();
    }
  };

  let inactivityTimer;
  const handleMouseMove = () => {
    setUserActive((state) => state || true);
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      setUserActive((state) => (state ? false : state));
    }, 60000);
  };

  const handleWindowBlur = () => {
    setRefreshCounter((state) => Math.max(state - 1, 0));
  };

  const handleWindowFocus = () => {
    setRefreshCounter((state) => (state !== 3 ? 3 : state));
  };

  useEffect(() => {
    clearTimeout(refreshTimerRef.current);
    if (refreshCounter > 0) {
      invalidateData();
      refreshTimerRef.current = setTimeout(() => {
        setRefreshCounter((state) => Math.max(state - 1, 0));
      }, 60000);
    }
    // eslint-disable-next-line
  }, [refreshCounter]);

  useEffect(() => {
    if (userActive) {
      setRefreshCounter((state) => (state !== 3 ? 3 : state));
    } else {
      setRefreshCounter((state) => (state !== 0 ? 0 : state));
    }
    // eslint-disable-next-line
  }, [userActive]);

  useEffect(() => {
    invalidateData();
    setRefreshCounter((state) => (state !== 3 ? 3 : state));
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    window.addEventListener("blur", handleWindowBlur);
    window.addEventListener("focus", handleWindowFocus);
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("blur", handleWindowBlur);
      window.removeEventListener("focus", handleWindowFocus);
      window.removeEventListener("mousemove", handleMouseMove);
    };
    // eslint-disable-next-line
  }, []);
};

export default useRefresher;
